// node_modules
import { FC, ChangeEvent, useState, useEffect } from "react";
// Controllers
import { CaseControllerSingleton } from "Controllers";
// Enums
import { ToastTypeEnum } from "Enums";
// Helpers
import { ToastHelperSingleton } from "Helpers";

// Const
const caseSolutionTypes: string[] = [
    "",
    "Application",
    "Coating",
    "Component",
    "Device",
    "Formula",
    "Framework",
    "Ingredient",
    "Market",
    "Material",
    "Method",
    "Partner",
    "Process",
    "Product",
    "Supplier",
    "System",
    "Technology"
];

export type TCaseSolutionTypeProps = {
    caseId: number,
    caseSolutionType?: string
};

export const CaseSolutionType: FC<TCaseSolutionTypeProps> = ({caseId, caseSolutionType}: TCaseSolutionTypeProps) => {
    // State
    const [solutionType, setSolutionType] = useState<string>("");

    // Logic
    useEffect(() => {
        // set component state
        setSolutionType(getFormattedSolutionType(caseSolutionType));
    }, [caseSolutionType]);

    const getFormattedSolutionType = (solutionType?: string): string => {
        // safety-checks
        if (!solutionType) { return ""; }

        // safety-checks
        let solutionTypeFormatted = solutionType.trim();
        if (!solutionTypeFormatted) { return ""; }
        
        // format
        solutionTypeFormatted = solutionTypeFormatted.toLowerCase();
        solutionTypeFormatted = solutionTypeFormatted.charAt(0).toUpperCase() + solutionTypeFormatted.slice(1);

        // safety-checks
        if (!caseSolutionTypes.includes(solutionTypeFormatted)) { 
            return ""; 
        } else {
            return solutionTypeFormatted;
        }
    };

    const updateCaseSolutionTypeAsync = async (changeEvent: ChangeEvent<HTMLSelectElement>): Promise<void> => {
        // safety-checks
        if (!changeEvent || 
                (changeEvent && !changeEvent.target) 
                || (changeEvent && changeEvent.target && !changeEvent.target.value)) { return; }
        
        // get new case solution type formatted
        const newCaseSolutionType: string = getFormattedSolutionType(changeEvent.target.value);

        // set component state
        setSolutionType(newCaseSolutionType);

        // call server to update case solution type
        const isSuccess = await CaseControllerSingleton.updateCaseSolutionTypeAsync(
            caseId,
            newCaseSolutionType
        );
        
        // tell user about update result 
        if (!isSuccess) {
            ToastHelperSingleton.showToast(ToastTypeEnum.Error, `Was not able to update case solution type to ${newCaseSolutionType}.`);
        } else {
            ToastHelperSingleton.showToast(ToastTypeEnum.Success, `Successfully updated case solution type to ${newCaseSolutionType}.`);
        }
        
        return;
    };

    return (
        <div>
            <h4>I&apos;m looking for a(n)</h4>
            <select value={solutionType} onChange={updateCaseSolutionTypeAsync}>
                {caseSolutionTypes.map((caseSolutionType: string)  => {
                    return (
                        <option key={caseSolutionType}>{caseSolutionType}</option>
                    );
                })}
            </select>
        </div>
    );
};